import React from "react";
import ReactWOW from 'react-wow';
import { $t } from '@/modules/i18n';

class About extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="about">
        <div className="container">
          <div className="title-block">
            <h2>{$t(msg.introduction)}</h2>
          </div>
          <p>{$t(msg.introLi01)}</p>
          <p>{$t(msg.introLi02)}</p>
          <p>{$t(msg.introLi03)}</p>
          {/* Organized */}
          <div className="flex-box">
            {
              msg.introData.map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="box box-2">
                      <h4>
                        <img src={require("@uh/assets/images/" + item.image)} style={{ width: "40px", marginRight: "12px" }} alt={item.name} />
                        {$t(item.title)}</h4>
                      {$t(item.desc).split('\n').map((item, key) => {
                        return (<p key={key}>{item}</p>);
                      })}
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
        </div>
      </section >
    )
  }
}

export default About;